import { render } from "./PendingOrderPopup.vue?vue&type=template&id=65fabbda&scoped=true"
import script from "./PendingOrderPopup.vue?vue&type=script&lang=js"
export * from "./PendingOrderPopup.vue?vue&type=script&lang=js"

import "./PendingOrderPopup.vue?vue&type=style&index=0&id=65fabbda&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65fabbda"]])

export default __exports__